import React from 'react';
import './SnagInfo.css';
import snagMenu from '../../Images/Menus/SnagMenu.jpg';

class SnagInfo extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.hideSnags();
  }

  render() {
    return (
      <div className="snagInfoAnchor">
        <div className="snagInfo">
          <img src={snagMenu} className="snagInfoBackground" alt="snagInfoBackground"/>
          <div className="snagGrid">
            <div className="snagDescription">There is an increasing chance of bad events happening which rewards you with a bonus if you complete the round. Play to discover them all!</div>
            <div className="snagBox">{this.props.snagInfo.noLights === true ? "No Lights" : "???"}</div><div className="snagBox">{this.props.snagInfo.noLights === true ? "Only the sound is played" : <div></div>}</div>
            <div className="snagBox">{this.props.snagInfo.noSound === true ? "No Sound" : "???"}</div><div className="snagBox">{this.props.snagInfo.noSound === true ? "Only the lights turn on" : <div></div>}</div>
            <div className="snagBox">{this.props.snagInfo.dud === true ? "Dud" : "???"}</div><div className="snagBox">{this.props.snagInfo.dud === true ? "The reminder is completely blank" : <div></div>}</div>
            <div className="snagBox">{this.props.snagInfo.spin === true ? "Spin" : "???"}</div><div className="snagBox">{this.props.snagInfo.spin === true ? "The board spins 90 degrees" : <div></div>}</div>
            <div className="snagBox">{this.props.snagInfo.blitzReminder === true ? "Rushed" : "???"}</div><div className="snagBox">{this.props.snagInfo.blitzReminder === true ? "Previous events displayed very quickly" : <div></div>}</div>
            <div className="snagBox">{this.props.snagInfo.extraEvent === true ? "Extra Event" : "???"}</div><div className="snagBox">{this.props.snagInfo.extraEvent === true ? "Two new events instead of one" : <div></div>}</div>
            <div className="snagBox">{this.props.snagInfo.extraButtons === true ? "Side Buttons" : "???"}</div><div className="snagBox">{this.props.snagInfo.extraButtons === true ? "Extra buttons turn on" : <div></div>}</div>
            <div className="closeBox" onClick={this.handleClick}>Close</div>
          </div>
        </div>
      </div>
    )
  }
}

export default SnagInfo;



// WEBPACK FOOTER //
// ./src/Components/SnagInfo/SnagInfo.js